import { MessageReader, MessageWriter } from "vscode-jsonrpc";

import { Disposable } from "vscode-jsonrpc";

import { Message } from "vscode-jsonrpc";

import { IConnection } from "vscode-ws-jsonrpc/lib/server/connection";
import { validateMessageUris, Validator } from "./uriValidators.js";
import { Logger } from "../utils/logger.js";

export class ValidatedConnection implements IConnection {
  constructor(private readonly connection: IConnection, private readonly validators: Validator[], private readonly logger: Logger) {
    this.connection = connection;
  }

  get reader(): MessageReader {
    return this.connection.reader;
  }

  get writer(): MessageWriter {
    return this.connection.writer;
  }

  onClose(callback: () => void): Disposable {
    return this.connection.onClose(callback);
  }

  forward(to: IConnection, map: (message: Message) => Message = (message) => message): void {
    this.reader.listen(input => {
      try {
        const output = map(input);

        validateMessageUris(output, ...this.validators);
        to.writer.write(output);
      } catch (error) {
        this.logger.error(`Invalid message: ${error instanceof Error ? error.message : String(error)}`);
        return;
      }
    });
  }

  dispose(): void {
    this.connection.dispose();
  }
}
